package com.neurobs.ccabserver.transcriptreview

import com.neurobs.ccab.IdentityData
import com.neurobs.ccab.db.TestData
import com.neurobs.ccabserver.administrator.contexts.{RecordCacheContext, UserContext}
import com.neurobs.ccabserver.administrator.controller.RecordCache
import com.neurobs.ccabserver.transcriptreview.components.errorview.ErrorView
import com.neurobs.ccabserver.transcriptreview.components.transcriptreview.{TestTranscriptReview, TestTranscriptReviewHolder}
import com.neurobs.ccabserver.transcriptreview.components.transcriptselection.TranscriptSelection
import com.neurobs.ccabserver.transcriptreview.states.{AudioContextContext, CommandRouter, CommandRouterContext, ConfidenceScreenStateProvider, ErrorState, ReviewSelectionState, TestTranscriptReviewStateProvider, TranscriptSelectionData, TranscriptSelectionState, UserState, VisibilityStateProvider}
import com.neurobs.js.ccab.{RelativeJSCCABServer, ServerContext}
import org.scalajs.dom
import org.scalajs.dom.{AudioBuffer, AudioContext}
import org.scalajs.dom.raw.Element
import slinky.core.{Component, FunctionalComponent}
import slinky.core.annotations.react
import slinky.web.ReactDOM
import slinky.web.html._
import slinky.core.facade.Hooks.{useContext, useEffect, useState}
import com.neurobs.errors.Result
import com.neurobs.js.util.ServerResponseUtil
import com.neurobs.js.view.ReactAudioViewer
import com.neurobs.js.view.AudioViewer
import com.neurobs.react.{Card, StyleUtil, WaitIcon}
import slinky.core.facade.React

import scala.concurrent.ExecutionContext.Implicits.global

class Main(targetDiv: Element, userData: IdentityData, allTests: Seq[TestData]) {
	ReactDOM.render(
		//Temp(),
		TranscriptReviewTool(userData = userData, allTests = allTests),
		targetDiv
	)
}

//@react
//object Temp {
//	val server = RelativeJSCCABServer()
//	case class Props()
//	val component = FunctionalComponent[Props] { _ =>
//		val (audio, setAudio) = useState[Option[Result[AudioBuffer]]](default = None)
//		useEffect(() => {
//			server.getSpeechAudioFileFile(id = 1)._2.flatMap(ServerResponseUtil.decodeAudioData).map(r => setAudio(Some(r)))
//		}, Vector())
//
//		audio match {
//			case None => div("Loading...")
//			case Some(res) => res match {
//				case Left(e) => div(s"Error: ${e.description}")
//				case Right(audio) =>
//					val viewer1 = new AudioViewer(audio, AudioViewer.NullDelegate)
//					val viewer2 = new AudioViewer(audio, AudioViewer.NullDelegate)
//					val options = AudioViewer.Options(
//						cursorColor = "white",
//						waveColor = "yellow",
//						pixelHeight = 300,
//						normalize = true,
//						pixelsPerSecond = 350,
//						spectogram = None
//					)
//					div(style := StyleUtil.makeStyle(("width", "90vw"), ("overflowX", "auto")))(
//						div(className := "row-container")(
//							div(className := "row-container-element")(
//								ReactAudioViewer(viewer1, options)
//							),
//							div(className := "row-container-element")(
//								ReactAudioViewer(viewer2, options)
//							)
//						)
//					)
//			}
//		}
//	}
//}

@react object TranscriptReviewTool {
	case class Props(userData: IdentityData, allTests: Seq[TestData])

	val component = FunctionalComponent[Props] { props =>
		AudioContextContext.provider(new AudioContext)(
			ServerContext.provider(RelativeJSCCABServer())(
				RecordCacheContext.provider(new RecordCache)(
					CommandRouterContext.provider(new CommandRouter)(
						ErrorState.provider()(
							UserState.provider(props.userData)(
								ReviewSelectionState.provider()(
									TranscriptSelectionState.provider(TranscriptSelectionData(allTests = props.allTests))(
										TranscriptSelection()
									),
									div(className := "ui divider"),
									ErrorView(),
									TestTranscriptReviewHolder()
								)
							)
						)
					)
				)
			)
		)
	}
}

@react object TranscriptReviewToolCard {
	type Props = Unit

	val component = React.memo(FunctionalComponent[Props] { _ =>
			val user = UserContext.accessState()
			val server = ServerContext.accessState()
			val (tests, setTests) = useState(Seq[TestData]())

			useEffect(() => {
				server.getTests()._2 map {
					case Left(_) =>
					case Right(t) => setTests(t)
				}
			}, Seq())

			Card(title = Some("Transcript Review"), onClose = None, onRefresh = None, fullWidth = true, dark = true)(
				if (tests.isEmpty) WaitIcon()
				else TranscriptReviewTool(userData = user.user.get, allTests = tests)
			)
		},
		(prevProps: Props, nextProps: Props) => prevProps == nextProps
	)
}
